module.exports = __webpack_public_path__ + "Banner_Chef_repeatable-869b4fd9b3192db9df260c7046c05044.svg";